var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _c(
            "span",
            {
              staticClass: "mr-2"
            },
            [_vm._v("Manage AutoSSL")]
          ),
          _c(
            "gg-btn",
            {
              staticClass: "mr-2",
              attrs: {
                loading: _vm.loading,
                "aria-label": "Refresh Auto SSL domains list."
              },
              on: {
                click: _vm.loadDisabledDomains
              }
            },
            [_c("v-icon", [_vm._v("mdi-refresh")])],
            1
          ),
          _c("start-auto-ssl"),
          _c(
            "v-tooltip",
            {
              attrs: {
                bottom: ""
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function fn(_ref) {
                    var on = _ref.on
                    return [
                      _c(
                        "v-icon",
                        _vm._g(
                          {
                            staticClass: "ml-2",
                            attrs: {
                              color: "primary",
                              small: ""
                            }
                          },
                          on
                        ),
                        [_vm._v(" mdi-help-circle ")]
                      )
                    ]
                  }
                }
              ])
            },
            [
              _c("span", [
                _vm._v(
                  "Enable or disable automatic Let's Encrypt SSL certificates by domain."
                )
              ])
            ]
          )
        ],
        1
      ),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              loading: _vm.loading || _vm.processing,
              items: _vm.sslDomainsList
            },
            scopedSlots: _vm._u([
              {
                key: "item.autoSslDisabled",
                fn: function fn(_ref2) {
                  var item = _ref2.item
                  return [
                    item.autoSslDisabled && item.type === "letsencrypt"
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "red",
                              "font-weight": "bold"
                            }
                          },
                          [_vm._v("Disabled")]
                        )
                      : item.type === "letsencrypt"
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "primary--text d-flex align-center flex-column",
                              staticStyle: {
                                "max-width": "fit-content"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "mb-1",
                                attrs: {
                                  src: "/static/img/amui/le-logo-lockonly.png",
                                  width: "28px",
                                  alt: "Let's Encrypt Enabled"
                                }
                              }),
                              _c("b", [_vm._v("Enabled")])
                            ]
                          )
                        ])
                      : item.type === "alphassl"
                      ? _c(
                          "div",
                          {
                            staticClass: "d-flex align-center flex-column",
                            staticStyle: {
                              "max-width": "fit-content"
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/static/img/amui/globalsign-logo-eye.png",
                                width: "24px",
                                alt: "GlobalSign"
                              }
                            }),
                            _c(
                              "b",
                              {
                                staticClass: "primary--text"
                              },
                              [_vm._v("Globalsign")]
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                }
              },
              {
                key: "item.manage",
                fn: function fn(_ref3) {
                  var item = _ref3.item
                  return [
                    _c("v-switch", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.type === "letsencrypt",
                          expression: "item.type === 'letsencrypt'"
                        }
                      ],
                      attrs: {
                        label: "",
                        color: "primary",
                        "input-value": !item.autoSslDisabled,
                        "true-value": true,
                        "false-value": false,
                        disabled: _vm.processing || _vm.loading
                      },
                      on: {
                        click: function click($event) {
                          return _vm.changeAutoSsl(
                            item.domain,
                            !item.autoSslDisabled
                          )
                        }
                      }
                    })
                  ]
                }
              },
              {
                key: "item.actions",
                fn: function fn(_ref4) {
                  var item = _ref4.item
                  return [
                    item.type === "letsencrypt"
                      ? _c(
                          "gg-btn",
                          {
                            attrs: {
                              to: {
                                name: "hosting_ssl_create",
                                query: {
                                  d: item.domain,
                                  sid: _vm.hosting.id
                                }
                              }
                            }
                          },
                          [_vm._v(" Upgrade ")]
                        )
                      : _c(
                          "gg-btn",
                          {
                            attrs: {
                              to: {
                                name: "hosting_ssl_manage",
                                params: {
                                  id: item.sslId
                                }
                              }
                            }
                          },
                          [_vm._v(" Manage ")]
                        )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }